module.exports = __webpack_public_path__ + "img/A98D6A_F2D3AB_FBE6BE_695332-256px.d5e08e81.png";